export const getComma = (number) => {
  if (!number) return '0'

  return parseInt(number).toLocaleString()
}
